export const MODAL_OPEN_PREMIUM = "modal/open/premium";
